import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCameraOff1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCameraOff1"><Path d="M9.5 3.5H14.5L16.5 6.5H21.5V16.5M2.5 2.5L21.5 21.5M14.7624 15.1495C14.1219 15.9714 13.1227 16.5 12 16.5C10.067 16.5 8.5 14.933 8.5 13C8.5 11.8791 9.02687 10.8813 9.84647 10.2408M6 6.5H2.5V20.5H20" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCameraOff1;
